import { ChangeEvent, FormEvent, useEffect, useState } from "react";
import DcddMembershiPlanForm from "./components/DcddMemershipPlanForm";
import { connect, useSelector } from "react-redux";
import { createDcddMembership } from "../store/action";
import {
  CreateDcddMembershipPlanInput,
  CreateDcddMembershipPlanInputError,
} from "../store/actionType";
import { FormValidation } from "./components/FormValidation";
type OwnProps = {
  closeModal: React.Dispatch<React.SetStateAction<boolean>>;
  packageId: string;
};
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = DispatchProps & OwnProps;
const HandleCreateDcddPlan: React.FC<Props> = ({
  onCreateMembership,
  closeModal,
  packageId,
}) => {
  const [formData, setFormData] = useState<CreateDcddMembershipPlanInput>({
    end_date: "",
    user_limit: 0,
    membership_plan: "",
    remarks: "",
  });
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState<CreateDcddMembershipPlanInputError>({});
  const [apiError, setApiError] = useState(null);
  const packageState = useSelector(
    (state: any) => state.dcddMembership?.genericDcddMembershipState
  );
  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setError((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const handleSave = async (e: FormEvent) => {
    e.preventDefault();

    const validationErrors = FormValidation(formData);
    if (Object.keys(validationErrors).length > 0) {
      setError(validationErrors);
      return;
    }
    if (formData.end_date.trim() !== "") {
      setSubmitted(true);
      setLoading(true);
      try {
        const input:CreateDcddMembershipPlanInput = {
          end_date: new Date(formData.end_date).toISOString(),
          user_limit: formData.user_limit,
          membership_plan: formData.membership_plan,
          remarks: formData.remarks,
        };
        await onCreateMembership(input);
      } catch (err) {
        console.error("Failed to create package:", err);
      } finally {
        setLoading(false);
      }
    }
  };
  useEffect(() => {
    if (!packageState.isLoading && submitted) {
      if (packageState.error) {
        setApiError(packageState.error); // show error
      } else {
        setApiError(null);
        closeModal(false);
      }
    }
  }, [packageState.isLoading, packageState.error, submitted]);
  return (
    <>
      <DcddMembershiPlanForm
        handleSave={handleSave}
        formData={formData}
        handleChange={handleChange}
        error={error}
        loading={loading}
        header={"Create DCDD Membership Plan"}
      />
    </>
  );
};
const mapDispatchToProps = (dispatch: any) => ({
  onCreateMembership: (createDcddPackageInput: CreateDcddMembershipPlanInput) =>
    dispatch(createDcddMembership(createDcddPackageInput)),
});
export default connect(null, mapDispatchToProps)(HandleCreateDcddPlan);
